import React from 'react';
import { ProcessTimeline } from '../sections/ProcessTimeline';
import { ButtonLink } from '../ui/ButtonLink';
import { SectionHeading } from '../ui/SectionHeading';
export function HomeProcess() {
  return <section className="bg-porcelain py-24 lg:py-32" data-id="element-263" data-mp="2js42ot0p0ysj">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-12 lg:px-10" data-id="element-264" data-mp="2jqt02wizhx30">
        <div className="lg:col-span-5" data-id="element-265" data-mp="2erzxhz58jqhm">
          <div className="lg:sticky lg:top-32" data-id="element-266" data-mp="2at0kdr9conf3">
            <SectionHeading label="Our search process" title="A Structured Approach to Exceptional Leadership." intro="Seven clearly defined stages give every search structure and transparency — so you always know where things stand and what comes next." data-id="element-267" data-mp="2atsh55eoor6y" />
            <ButtonLink to="/employers#inquiry" arrow className="mt-10" data-id="element-268" data-mp="1vxb7cim57kmi">
              Start a Search Conversation
            </ButtonLink>
          </div>
        </div>
        <div className="lg:col-span-6 lg:col-start-7" data-id="element-269" data-mp="3qaj2kbe15y8o">
          <ProcessTimeline data-id="element-270" data-mp="qj9s6rrvensl" />
        </div>
      </div>
    </section>;
}